<template>
	<footer class="footer" id="footer">
    <div class="section join-section" v-if="!$parent.isAuth || ($parent.isAuth && $route.name === 'Home')">
      <!-- размытие для join section -->
      <img src="../images/footer-blur.png" class="join-blur"/>
      <div class="wrapper">
        <div class="title big">{{$t('Join us today')}}</div>
        <div class="title">and begin your unique {{$t("adventure")}} in the world of Rust!</div>
        <div class="buttons">
          <button
            v-if="ipAndPort"
            v-clipboard="ipAndPort"
            v-clipboard:success="clipboardSuccessHandler"
            class="button"
          >
            {{ copied ? "Copied" : "Join" }}
          </button>
          <router-link to="/contact-us" class="button support">{{ $t(`Support`) }}</router-link>
        </div>
      </div>
    </div>
    <div class="section nav-section">
      <div class="wrapper">
        <ul class="nav">
          <li class="nav__item">
            <router-link to="/products" class="title small">{{ $t(`ITEMS`) }}</router-link>
          </li>
          <li class="nav__item">
            <router-link to="/" class="title small">{{ $t(`HOME`) }}</router-link>
          </li>
          <li class="nav__item" v-for=" (item, i) in $parent.textPageList" :key="i">
            <a @click="$emit('goToPage', item.slug ? item.slug : item.id)" class="title small" >
              {{ item.title }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="section footer-section">
      <div class="wrapper">
        <div class="left">
          <div class="desc">
            {{ $parent.settings.copyright }}
            <br/>
            © {{ new Date().getFullYear() }}
          </div>
        </div>
        <div class="right">
          <div class="desc">
            {{ $parent.settings.requisites }}
          </div>
          <div class="desc">
            Contact: <a :href="'mailto:' + $parent.settings.support_email">{{ $parent.settings.support_email }}</a>
          </div>
          <div class="social-links">
            <a v-for="socialLink in socialLinks" :key="socialLink.link" :href="socialLink.link" class="social-link" target="_blank" rel="noopener noreferrer">
              <img :src="socialLink.image" alt="social" class="social-icon"/>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="section methods-section">
      <div class="wrapper">
        <div class="left" v-if="footerImages.length">
          <img
            v-for="(img, i) in footerImages"
            :key="i"
            :src="img.url"
            :style="img.height ? { height: img.height + 'px' } : {}"
            class="img"
          />
        </div>
        <div class="left" v-else>
          <img src="../images/visa.svg" class="img"/>
          <img src="../images/mc_symbol.svg" class="img"/>
          <img alt="appleplay image" class="img applepay" src="../images/apple-pay.svg" />
          <img alt="googlepay image" class="img googlepay" src="../images/google-pay.svg" />
          <img src="../images/3ds.svg" class="img"/>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import Vue from 'vue'
import Clipboard from 'v-clipboard'
Vue.use(Clipboard)


export default {
	name: 'Footer',
	props: {
		serverIp: { type: String, default: '' },
		serverPort: { type: [String, Number], default: '' },
		paymentMethods: { type: Array, default: () => [] },
	},
	data: function() {
		return {
      copied: false,
      socialLinks: []
		}
	},
	computed: {
    ipAndPort() {
      if (this.serverIp && this.serverPort) {
        return `${this.serverIp}:${this.serverPort}`;
      }
      return null;
    },
    footerImages() {
      const images = [];
      this.paymentMethods.forEach(m => {
        if (m.footer_images && m.footer_images.length) {
          m.footer_images.forEach(img => {
            if (img.url) images.push(img);
          });
        }
      });
      return images;
    },
  },
	methods: {
    clipboardSuccessHandler() {
      let self = this;
      self.copied = true;
      setTimeout(() => {
        self.copied = false;
      }, 1200);
    },
    fetchSocialLinks() {
      this.$http.get(process.env.VUE_APP_API+'social-links').then((res) => {
      this.socialLinks = res.data.payload
      })
      .catch((res) => {
        if(res.response.status === 401) {
          this.openSignInModal();
        }
      })
    }
	},
	mounted() {
    this.fetchSocialLinks()
  }
}
</script>

<style scoped>
.social-links {
  display: flex;
  gap: 12px;
  margin-top: 12px;
}

.social-link {
  display: inline-block;
  transition: transform 0.2s ease;
}

.social-link:hover {
  transform: scale(1.1);
}

.social-icon {
  width: 24px;
  height: 24px;
  color: white;
  transition: color 0.2s ease;
}

.social-link:hover .social-icon {
  color: #ccc;
}

/* Делаем иконку Instagram чуть шире */
.social-link:first-child .social-icon {
  width: 32px;
}
</style>
